import React, { useEffect, useState, useRef } from "react";
import useWebSocket, { ReadyState } from "react-use-websocket";
import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";
import {
  PaperClipIcon,
  PhotographIcon,
  PaperAirplaneIcon,
} from "@heroicons/react/outline";
import axiosInstance from "../../../Service/Interceptor";
import Login from "../UserAuth/Login/Login";
import { toast, ToastContainer } from "react-toastify";

function useChatScroll(dep) {
  const ref = useRef();
  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTop = ref.current.scrollHeight;
    }
  }, [dep]);
  return ref;
}

const Chats = () => {
  let token = Cookies.get("access_token");
  let decoded = jwt_decode(token);
  const [chatList, setChatList] = useState([]);
  const [messageHistory, setMessageHistory] = useState([]);
  const [message, setMessage] = useState("");
  const [openChat, setOpenChat] = useState([]);
  const [loadMessage, setLoadMessage] = useState();
  const ref = useChatScroll(loadMessage);

  let location = window.location;
  let wsStart = 'ws://'

  if(location.protocol == 'https:') {
      wsStart = 'wss://'
  }

  useEffect(() => {
    axiosInstance
      .get("users/api/v1/messages/")
      .then((res) => {
    
        setChatList(res.data);
        setOpenChat(res.data.results[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  },[]);


  useEffect(() => {
    if (openChat?.receiver_data?.receiver_uuid) {
      axiosInstance
        .get(`users/api/v1/messages/${openChat?.receiver_data?.receiver_uuid}/`)
        .then((res) => {
          console.log(res)
          setLoadMessage(res.data);
       
        //   sendJsonMessage({
        //     type: "read_messages"
        // })
        })
        .catch((err) => {
          console.log(err);
         
        });
    }
  }, [openChat, messageHistory]);

  let [socketUrl, setSocketUrl] = useState(`${wsStart}buyduy-user.cstdev.live/ws/chat/${openChat?.receiver_data?.receiver_uuid}/?token=${token}`);

  let { readyState, sendJsonMessage,sendMessage } =  useWebSocket(
    socketUrl,
   {
     onOpen: () => {
       console.log("Connected!");
     },
     onClose: () => {
       console.log("Disconnected!");
     },
     onMessage: (e) => {
       const data = JSON.parse(e.data);
       setMessageHistory((prev) => prev.concat(data));
     },
     retryOnError: openChat?.receiver_data?.receiver_uuid ? true : false,
     shouldReconnect: (CloseEvent) => {
        return openChat?.receiver_data?.receiver_uuid ? messageHistory.length > 0 : false;
     }
   } 
   );

  const onChangeOpenChat = (item) => {

  setOpenChat(item);
  setSocketUrl(`${wsStart}buyduy-user.cstdev.live/ws/chat/${item?.receiver_data?.receiver_uuid}/?token=${token}`)
  console.log(item)
  // setMessage("");

    
  };

useEffect(()=>{
 if(openChat?.length!==0){
    setSocketUrl(`${wsStart}buyduy-user.cstdev.live/ws/chat/${openChat?.receiver_data?.receiver_uuid}/?token=${token}`)
 }

},[openChat])

//  regional admin UUId: f3e5f246-82ca-4b1a-be5f-a79d9d874eb1

  function handleChangeMessage(e) {
    setMessage(e.target.value);
  }

  const handleSubmit = () => {
    let messageObje={
      type: "chat_message",
      message: message
    }
    // console.log(messageObje, 'before sent');
    sendJsonMessage(messageObje);
    setMessage("");
  };

  const connectionStatus = {
    [ReadyState.CONNECTING]: "Connecting",
    [ReadyState.OPEN]: "Open",
    [ReadyState.CLOSING]: "Closing",
    [ReadyState.CLOSED]: "Closed",
    [ReadyState.UNINSTANTIATED]: "Uninstantiated",
  }[readyState];
 
  return (
    <>
      {token ? (
        <div className="relative">
          <div className="chat-area px-5 py-2">
            <h2 className="text-[#282828] text-lg mb-3 font-semibold">Chats</h2>
            <section className="grid grid-cols-12 h-full">
              {/* All Chats list */}
              <div className="col-span-4 p-4 bg-white drop-shadow-[0px_8px_10px_rgba(44,141,255,0.29)] rounded-tl-md  mr-1">
                {chatList?.count == 0 ? (
                  <h1 className="text-red-600">No Chat List!!</h1>
                ) : (
                  <>
                    {chatList?.results?.map((chatlist, index) => (
                      <div
                        className="flex items-start space-x-2 my-2 shadow-md p-2 cursor-pointer"
                        onClick={() => onChangeOpenChat(chatlist)}
                        key={index}
                      >
                        <div className="flex-1">
                          <h1 className="text-blue-500 font-semibold">
                            {chatlist.receiver_data.receiver_name
                              .split('"')
                              .join("")}
                          </h1>
                          <p className="text-sm">
                            {chatlist.latest_message.length > 45
                              ? chatlist.latest_message.split('"').join("") +
                                ".."
                              : chatlist.latest_message.split('"').join("")}

                           
                          </p>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>

              {chatList?.count==0? <div className="col-span-8 py-3  rounded-tr-md ">

                </div>
                :
                <div className="col-span-8 py-3 rounded-tr-md bg-white drop-shadow-[0px_8px_10px_rgba(44,141,255,0.29)] ml-1">
                {/* Chat Header */}
                <div>
                  <div className="flex items-center space-x-2 pb-2 pl-4 pr-4 border-b border-gray-200 mb-2">
                    <div>
                      <img
                        src="/images/logo.png"
                        alt=""
                        className="h-12 w-12 rounded-full object-contain"
                      />
                    </div>
                    <div className="flex-1">
                      <h1 className="text-xl">
                        {openChat?.receiver_data?.receiver_name}
                      </h1>
                    </div>
                  </div>
                </div>

                {/* Chat Messages */}
                <div className="h-96 overflow-y-auto  pl-4 pr-2" ref={ref}>
                  {/* Day Wise Show */}

                  {loadMessage?.results.map((message, index) => (
                    <div key={index}>
                      <div className="day-exec my-2 text-gray-400 text-sm text-center py-2">
                        {message.created_at}
                      </div>
                      {message.receiver.uuid ==
                      openChat?.receiver_data?.receiver_uuid ? (
                        <div>
                          <div className="bg-[#0073FA] p-2 rounded-lg max-w-xs ml-auto text-white my-1">
                            {message.content.split('"').join("")}
                          </div>
                        </div>
                      ) : (
                        <div className="flex space-x-1 items-end">
                          <div className="space-y-2">
                            <p className="bg-[#FAFAFA] rounded-lg px-2 py-2">
                              {message.content.split('"').join("")}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                {/* Send Message box */}
                <div className="py-3 ml-4 mr-5 border-t-2 border-gray-100 mt-4">
                  <div className="relative">
                    <input
                      name="message"
                      onChange={handleChangeMessage}
                      value={message}
                      required
                      placeholder="Write Something ..."
                      className="placeholder:text-sm py-3 pl-5 pr-36 rounded-full bg-gray-100 w-full focus:outline-none"
                    />
                    <div className="space-x-4 absolute right-0 -top-1">
                      {/* <button type='button' className='rounded-full focus:ring-2 focus:ring-offset-2 ring-offset-gray-100 ring-gray-500 focus:bg-white'>
                                      <PaperClipIcon className='h-6 text-gray-500' />
                                  </button>
                                  <button type='button' className='rounded-full focus:ring-2 focus:ring-offset-2 ring-offset-gray-100 ring-gray-500 focus:bg-white'>
                                      <PhotographIcon className='h-6 text-gray-500' />
                                  </button> */}
                      {message !== "" && (
                        <button
                          type="submit"
                          onClick={handleSubmit}
                          className="rotate-90 p-4 bg-blue-600 rounded-full text-white"
                        >
                          <PaperAirplaneIcon className="h-6" />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>}
            </section>
          </div>
        </div>
      ) : (
        <Login />
      )}
    </>
  );
};

export default Chats;
